/*ENGINE-START*/
/* HeirKnit: draws the blanket stitch for stitch. Charted from the photo of the physical sample
   (design/brand/reference). Used by the page and by tools/render_studio.py. */
var HeirKnit=(function(){
  'use strict';
  var F={
    A:['001100','011110','110011','110011','111111','110011','110011'],B:['111110','110011','110011','111110','110011','110011','111110'],
    C:['011110','110011','110000','110000','110000','110011','011110'],D:['111100','110110','110011','110011','110011','110110','111100'],
    E:['111111','110000','110000','111110','110000','110000','111111'],F:['111111','110000','110000','111110','110000','110000','110000'],
    G:['011110','110011','110000','110111','110011','110011','011110'],H:['110011','110011','110011','111111','110011','110011','110011'],
    I:['11','11','11','11','11','11','11'],J:['000011','000011','000011','000011','110011','110011','011110'],
    K:['110011','110110','111100','111000','111100','110110','110011'],L:['110000','110000','110000','110000','110000','110000','111111'],
    M:['1100011','1110111','1111111','1101011','1100011','1100011','1100011'],N:['110011','111011','111011','110111','110111','110011','110011'],
    O:['011110','110011','110011','110011','110011','110011','011110'],P:['111110','110011','110011','111110','110000','110000','110000'],
    Q:['011110','110011','110011','110011','110111','110110','011011'],R:['111110','110011','110011','111110','110110','110011','110011'],
    S:['011111','110000','110000','011110','000011','000011','111110'],T:['111111','001100','001100','001100','001100','001100','001100'],
    U:['110011','110011','110011','110011','110011','110011','011110'],V:['110011','110011','110011','110011','110011','011110','001100'],
    W:['1100011','1100011','1100011','1101011','1111111','1110111','1100011'],X:['110011','110011','011110','001100','011110','110011','110011'],
    Y:['110011','110011','011110','001100','001100','001100','001100'],Z:['111111','000011','000110','001100','011000','110000','111111'],
    '-':['0000','0000','0000','1111','0000','0000','0000'],"'":['11','11','10','00','00','00','00'],' ':['000','000','000','000','000','000','000']
  };
  /* Six colourways. The blanket is DOUBLE SIDED: the front knits the name and border in `ink`
     on a `field`; the back is the same design with the two colours exchanged (and, like any
     knit turned over, mirrored left to right). Only chocolate is confirmed from the physical
     sample; the other five are placeholders until Davy names the real yarns. */
  var YARNS={
    chocolate:{label:'Chocolate and Bone',a:'Chocolate',b:'Bone',ink:'#4A3426',field:'#EFE9DC'},
    grey:{label:'Grey and Bone',us:'Gray and Bone',a:'Grey',ua:'Gray',b:'Bone',ink:'#A9A7A2',field:'#EFE9DC'},  /* label = the Shopify variant title, never shown-only; us/ua = how it reads outside the UK */
    rose:{label:'Rose and Bone',a:'Rose',b:'Bone',ink:'#B07F79',field:'#F2ECE2'},
    dusk:{label:'Blue and Bone',a:'Blue',b:'Bone',ink:'#5C6F84',field:'#EFE9DC'},
    charcoal:{label:'Charcoal and Bone',a:'Charcoal',b:'Bone',ink:'#3C3C3C',field:'#EFE9DC'},
    taupe:{label:'Taupe and Bone',a:'Taupe',b:'Bone',ink:'#9A836B',field:'#F1EBDF'}
  };
  /* Layout in stitches. Even name rows are MIRRORED and run edge to edge; odd rows are upright
     and drop the first and last column, so names still sit in straight columns. */
  var L={border:16,pad:3,letterGap:2,wordGap:5,rowGap:3,nameRows:43,fieldW:373,max:12};
  L.pitch=7+L.rowGap;L.fieldH=L.nameRows*L.pitch-L.rowGap;
  L.cols=2*(L.border+L.pad)+L.fieldW;L.rows=2*(L.border+L.pad)+L.fieldH;
  /* The real blanket is 90cm x 90cm. A knit stitch is wider than it is tall, so give stitches the
     height that makes the counted stitches come out square (about 0.88), rather than changing the counts. */
  L.size='90cm x 90cm';L.stitchH=L.cols/L.rows;

  function clean(v){return String(v).toUpperCase().replace(/[‘’]/g,"'").replace(/[^A-Z '\-]/g,'').replace(/\s+/g,' ').replace(/^\s/,'').slice(0,L.max);}
  function hex(h){return[parseInt(h.slice(1,3),16),parseInt(h.slice(3,5),16),parseInt(h.slice(5,7),16)];}
  function tint(h,a){var c=hex(h);return'rgb('+c.map(function(v){return Math.max(0,Math.min(255,Math.round(v*(1+a))));}).join(',')+')';}
  function jit(c,r){var n=((c*73856093)^(r*19349663))>>>0;return((n%97)/97-.5)*.07+(r%2?.012:-.012);}

  /* One stockinette stitch: a fat V, darker edge first, then a lit left leg and a shaded right leg. */
  function stitch(g,c,r,color,cw,ch,jc,jr){
    var x=c*cw,y=r*ch,a=jit(jc===undefined?c:jc,jr===undefined?r:jr),mx=x+cw*.5,by=y+ch*.94,ty=y-ch*.34;
    g.lineCap='round';
    g.strokeStyle=tint(color,a-.2);g.lineWidth=cw*.6;
    g.beginPath();g.moveTo(x+cw*.2,ty);g.lineTo(mx,by);g.moveTo(x+cw*.8,ty);g.lineTo(mx,by);g.stroke();
    g.lineWidth=cw*.46;
    g.strokeStyle=tint(color,a-.05);g.beginPath();g.moveTo(x+cw*.8,ty);g.lineTo(mx,by);g.stroke();
    g.strokeStyle=tint(color,a+.035);g.beginPath();g.moveTo(x+cw*.2,ty);g.lineTo(mx,by);g.stroke();
  }

  function plan(name){
    var glyphs=clean(name).replace(/\s+$/,'').split('').map(function(ch){return F[ch]||F[' '];});
    if(!glyphs.length)return null;
    var sep=new Array(L.letterGap+1).join('0'),bmp=[];
    for(var i=0;i<7;i++)bmp.push(glyphs.map(function(gl){return gl[i];}).join(sep));
    var mir=bmp.map(function(row){return row.split('').reverse().join('');});
    var W=bmp[0].length,period=W+L.wordGap,n=Math.max(1,Math.floor((L.fieldW+L.wordGap)/period)),used=n*period-L.wordGap;
    return{bmp:bmp,mir:mir,W:W,period:period,n:n,used:used,uStart:n>=3?1:0,uCount:n>=3?n-2:n,
      x0:L.border+L.pad+Math.floor((L.fieldW-used)/2),y0:L.border+L.pad};
  }
  function isInk(pl,c,r){
    if(c<L.border||r<L.border||c>=L.cols-L.border||r>=L.rows-L.border)return true;
    if(!pl)return false;
    var rr=r-pl.y0,cc=c-pl.x0;
    if(rr<0||rr>=L.fieldH||cc<0||cc>=pl.used)return false;
    var i=Math.floor(rr/L.pitch),within=rr%L.pitch,j=Math.floor(cc/pl.period),x=cc%pl.period,mirrored=i%2===0;
    if(within>=7||x>=pl.W)return false;
    if(!mirrored&&(j<pl.uStart||j>=pl.uStart+pl.uCount))return false;
    return(mirrored?pl.mir:pl.bmp)[within][x]==='1';
  }

  var tiles={};
  function tile(color,cw){
    var key=color+cw;if(tiles[key])return tiles[key];
    var T=48,cv=document.createElement('canvas');cv.width=T*cw;cv.height=T*cw;
    var g=cv.getContext('2d');g.fillStyle=tint(color,-.28);g.fillRect(0,0,cv.width,cv.height);
    for(var r=-1;r<=T;r++)for(var c=-1;c<=T;c++)stitch(g,c,r,color,cw,cw,(c+T)%T,(r+T)%T);
    return tiles[key]=cv;
  }
  function sprite(pl,rows,ink,cw){
    var sp=document.createElement('canvas');sp.width=(pl.W+2)*cw;sp.height=9*cw;
    var g=sp.getContext('2d');
    for(var r=0;r<7;r++)for(var c=0;c<pl.W;c++)if(rows[r][c]==='1')stitch(g,c+1,r+1,ink,cw,cw);
    return sp;
  }
  /* One whole side of the blanket at cw device pixels per stitch. */
  function sheet(pl,field,ink,cw){
    var cv=document.createElement('canvas');cv.width=L.cols*cw;cv.height=L.rows*cw;
    var g=cv.getContext('2d'),b=L.border;
    g.fillStyle=g.createPattern(tile(ink,cw),'repeat');g.fillRect(0,0,cv.width,cv.height);
    g.fillStyle=g.createPattern(tile(field,cw),'repeat');g.fillRect(b*cw,b*cw,(L.cols-2*b)*cw,(L.rows-2*b)*cw);
    if(pl){
      var up=sprite(pl,pl.bmp,ink,cw),mi=sprite(pl,pl.mir,ink,cw);
      for(var i=0;i<L.nameRows;i++){
        var m=i%2===0,from=m?0:pl.uStart,to=m?pl.n:pl.uStart+pl.uCount;
        for(var j=from;j<to;j++)g.drawImage(m?mi:up,(pl.x0+j*pl.period-1)*cw,(pl.y0+i*L.pitch-1)*cw);
      }
    }
    return cv;
  }
  function sheets(name,yarn,cw){
    var pl=plan(name),y=YARNS[yarn];
    return{pl:pl,front:sheet(pl,y.field,y.ink,cw),back:sheet(pl,y.ink,y.field,cw)};
  }

  /* Studio view: the blanket laid flat on a pale ground, soft shadow, one corner folded back
     to show the reverse, where the two colours swap. */
  function studio(cv,sh,o){
    o=o||{};
    function flipH(src){var f=document.createElement('canvas');f.width=src.width;f.height=src.height;var fg=f.getContext('2d');fg.translate(f.width,0);fg.scale(-1,1);fg.drawImage(src,0,0);return f;}
    /* Front up: the flap shows the back. Back up: everything is seen from behind, so mirrored. */
    var back=o.side==='back';
    if(back&&!sh.backUp){sh.backUp=flipH(sh.back);sh.frontFlap=flipH(sh.front);}
    var top=back?sh.backUp:sh.front,flap=back?sh.frontFlap:sh.back;
    var W=cv.width,H=cv.height,g=cv.getContext('2d'),m=(o.margin===undefined?.11:o.margin)*W;
    g.setTransform(1,0,0,1,0,0);g.fillStyle=o.bg||'#EEECE7';g.fillRect(0,0,W,H);
    var ratio=(sh.front.height/sh.front.width)*L.stitchH,bw=W-2*m,bh=bw*ratio;
    if(bh>H-2*m){bh=H-2*m;bw=bh/ratio;}
    var x=(W-bw)/2,y=(H-bh)/2,X=x+bw,Y=y+bh,f=o.fold===false?0:bw*.24,k=X+Y-f;
    function body(){g.beginPath();g.moveTo(x,y);g.lineTo(X,y);g.lineTo(X,Y-f);g.lineTo(X-f,Y);g.lineTo(x,Y);g.closePath();}
    g.save();body();g.shadowColor='rgba(45,32,20,.30)';g.shadowBlur=W*.04;g.shadowOffsetY=W*.018;g.fillStyle='#d9d3c8';g.fill();g.restore();
    g.save();body();g.clip();g.imageSmoothingQuality='high';g.drawImage(top,x,y,bw,bh);g.restore();
    if(f){
      g.save();g.beginPath();g.moveTo(X-f,Y);g.lineTo(X,Y-f);g.lineTo(X-f,Y-f);g.closePath();
      g.shadowColor='rgba(30,20,10,.42)';g.shadowBlur=f*.16;g.shadowOffsetX=-f*.035;g.shadowOffsetY=-f*.035;g.fillStyle='#777';g.fill();
      g.shadowColor='transparent';g.clip();
      g.setTransform(0,-1,-1,0,k,k);g.imageSmoothingQuality='high';g.drawImage(flap,x,y,bw,bh);g.setTransform(1,0,0,1,0,0);
      var cr=g.createLinearGradient(X-f*.5,Y-f*.5,X-f,Y-f);cr.addColorStop(0,'rgba(20,12,5,.34)');cr.addColorStop(.35,'rgba(20,12,5,0)');
      g.fillStyle=cr;g.fillRect(X-f,Y-f,f,f);
      g.restore();
    }
  }

  /* Macro view: a window onto the blanket at a size where every stitch can be seen.
     o.cols stitches across, starting at stitch (o.ox,o.oy). o.ink=false leaves the letters out. */
  function macro(cv,pl,yarn,o){
    var y=YARNS[yarn],g=cv.getContext('2d'),W=cv.width,H=cv.height,cw=W/o.cols,ch=cw*(o.stitchH||L.stitchH),rows=Math.ceil(H/ch)+1,c,r,on;
    var back=o.side==='back',inkC=back?y.field:y.ink,fieldC=back?y.ink:y.field;function mc(c){return back?L.cols-1-c:c;}
    g.setTransform(1,0,0,1,0,0);
    for(r=0;r<rows;r++)for(c=0;c<o.cols;c++){
      on=isInk(o.ink===false?null:pl,mc(c+o.ox),r+o.oy);
      g.fillStyle=tint(on?inkC:fieldC,-.28);g.fillRect(Math.floor(c*cw),Math.floor(r*ch),Math.ceil(cw)+1,Math.ceil(ch)+1);
    }
    for(r=-1;r<rows;r++)for(c=0;c<o.cols;c++){
      on=isInk(o.ink===false?null:pl,mc(c+o.ox),r+o.oy);
      stitch(g,c,r,on?inkC:fieldC,cw,ch,mc(c+o.ox),r+o.oy);
    }
    if(o.light!==false){
      var a=g.createLinearGradient(0,0,W,H);a.addColorStop(0,'rgba(255,250,240,.16)');a.addColorStop(.45,'rgba(255,250,240,0)');a.addColorStop(1,'rgba(25,15,5,.22)');
      g.fillStyle=a;g.fillRect(0,0,W,H);
      var v=g.createRadialGradient(W/2,H/2,Math.min(W,H)*.35,W/2,H/2,Math.max(W,H)*.75);v.addColorStop(0,'rgba(20,12,5,0)');v.addColorStop(1,'rgba(20,12,5,.26)');
      g.fillStyle=v;g.fillRect(0,0,W,H);
    }
  }
  return{L:L,YARNS:YARNS,clean:clean,plan:plan,isInk:isInk,sheets:sheets,studio:studio,macro:macro};
})();
/*ENGINE-END*/

(function(){
  'use strict';
  var K=HeirKnit,$=function(id){return document.getElementById(id);};
  var knit=$('knit'),close=$('knitClose'),hero=$('heroKnit'),input=$('babyName'),form=$('buyForm');
  var still=window.matchMedia('(prefers-reduced-motion: reduce)').matches||/^#static/.test(location.hash);
  var state={name:'',yarn:'chocolate'},view='whole',side='front',sh=null,shKey='',heroT=0,raf=0;

  /* One price for the whole page. As a file it is the text in the markup. On the store it is
     Shopify's own variant price, so the page and the checkout can never disagree. */
  var PRICE=$('price').textContent;
  (function(){
    var shop=window.HEIR_SHOP;if(!shop)return;
    var first=null;for(var k in shop.variants){first=shop.variants[k];break;}
    if(!first)return;
    var n=first.price/100;PRICE=(shop.symbol||'$')+(n%1?n.toFixed(2):String(n));
    $('price').textContent=PRICE;$('bagTotal').textContent=PRICE;
  })();

  function size(cv){var d=Math.min(window.devicePixelRatio||1,2),w=Math.round(cv.clientWidth*d),h=Math.round(cv.clientHeight*d);if(cv.width!==w||cv.height!==h){cv.width=w;cv.height=h;}return d;}

  var LATER='To follow';
  function shown(){return state.later?'HEIR':state.name;}   /* what the preview knits */
  function drawStage(){
    if(view==='whole'){
      size(knit);
      var cw=Math.max(2,Math.ceil(knit.width*.78/K.L.cols));
      var key=shown()+'|'+state.yarn+'|'+cw;if(key!==shKey){sh=K.sheets(shown(),state.yarn,cw);shKey=key;}
      K.studio(knit,sh,{side:side});
    }else{
      size(close);
      var pl=K.plan(shown()),narrow=close.clientWidth<480;
      K.macro(close,pl,state.yarn,{side:side,cols:narrow?46:64,ox:pl?pl.x0+pl.period-(narrow?10:16):K.L.border-6,oy:K.L.border-3});
    }
    drawMini();
  }
  /* Phones: the preview sits above the form, so it is off screen while choosing. Mirror it. */
  function drawMini(){
    var m=$('miniKnit');if(!m||!m.clientWidth)return;
    size(m);var src=view==='whole'?knit:close,g=m.getContext('2d');
    g.imageSmoothingQuality='high';g.clearRect(0,0,m.width,m.height);g.drawImage(src,0,0,m.width,m.height);
  }

  /* Knit band (opens the gallery): the name at macro scale, knitted in from the bottom row up the first time it scrolls into view. */
  function drawHero(animate){
    cancelAnimationFrame(raf);size(hero);
    var pl=K.plan(shown()||'HEIR'),cols=Math.max(40,Math.round(hero.clientWidth/9.5)),o={cols:cols,ox:pl.x0+(pl.n>=3?pl.period:0)+4,oy:pl.y0+3};
    if(!animate||still){K.macro(hero,pl,state.yarn,o);return;}
    var full=document.createElement('canvas'),plain=document.createElement('canvas');
    full.width=plain.width=hero.width;full.height=plain.height=hero.height;
    K.macro(full,pl,state.yarn,o);K.macro(plain,pl,state.yarn,{cols:o.cols,ox:o.ox,oy:o.oy,ink:false});
    var g=hero.getContext('2d'),H=hero.height,W=hero.width,band=(W/cols)*K.L.stitchH*K.L.pitch,bands=Math.ceil(H/band)+1,start=null,dur=2400;
    (function frame(t){
      if(start===null)start=t;
      var p=Math.min(1,(t-start)/dur),e=1-Math.pow(1-p,3),v=e*bands,done=Math.floor(v),frac=v-done,yDone=H-done*band,i=bands-done;
      g.drawImage(plain,0,0);
      g.save();g.beginPath();g.rect(0,yDone,W,H-yDone);
      if(i%2)g.rect(W*(1-frac),yDone-band,W*frac,band);else g.rect(0,yDone-band,W*frac,band);
      g.clip();g.drawImage(full,0,0);g.restore();
      if(p<1)raf=requestAnimationFrame(frame);else g.drawImage(full,0,0);
    })(performance.now());
  }

  /* What the page calls a colourway: the Shopify title in the UK, the US spelling everywhere else (Davy, 2026-10-14: Gray and Bone). Orders always carry the title. */
  function isGB(){return !!(window.HEIR_SHOP&&window.HEIR_SHOP.gb);}
  function yname(y){return isGB()?y.label:(y.us||y.label);}
  function ycol(y,k){return isGB()?y[k]:(y['u'+k]||y[k]);}
  function labels(){
    var y=K.YARNS[state.yarn];
    $('nameCount').textContent=state.name.length+' of '+K.L.max;
    $('barName').textContent=state.later?'Name to follow':(state.name||'Add a name');
    $('barMeta').textContent=yname(y)+' · '+PRICE;
    $('yarnName').textContent=yname(y);
    $('spellName').textContent=state.name||'';$('spellName').parentNode.childNodes[0].textContent=state.name?'Check the spelling: ':'Check the spelling';
    var bk=side==='back';
    $('sideLine').textContent=(bk?'Back':'Front')+' · '+(bk?ycol(y,'b'):ycol(y,'a'))+' on '+(bk?ycol(y,'a'):ycol(y,'b'));
    $('flipLabel').textContent=bk?'See the front':'See the back';$('flipBtn').setAttribute('aria-pressed',bk?'true':'false');
    knit.setAttribute('aria-label',(bk?'The back of the blanket':'The front of the blanket')+' in '+yname(y)+(state.name?', with the name '+state.name+' knitted in rows across it and one corner folded over to show the other side':'. No name yet.'));
  }
  function save(){try{localStorage.setItem('heir:personalisation:v4',JSON.stringify(state));}catch(e){}}
  function load(){try{var s=JSON.parse(localStorage.getItem('heir:personalisation:v4')||'null');if(s&&K.YARNS[s.yarn]&&typeof s.name==='string'){state.yarn=s.yarn;state.name=K.clean(s.name);input.value=state.name?state.name.charAt(0)+state.name.slice(1).toLowerCase():'';return true;}}catch(e){}return false;}
  function changed(){labels();drawStage();save();clearTimeout(heroT);heroT=setTimeout(function(){drawHero(false);},180);}

  if(still){var tk=document.querySelector('.announce__track');if(tk)tk.style.animationPlayState='paused';}
  if(!load())state.name=K.clean(input.value);
  /* review hooks for screenshots: #static&back&yarn=grey */
  if(/[#&]back\b/.test(location.hash))side='back';
  var hy=(location.hash.match(/yarn=([a-z]+)/)||[])[1];if(hy&&K.YARNS[hy])state.yarn=hy;
  (function(){var sw=form.querySelector('input[name=yarn][value='+state.yarn+']');if(sw){sw.checked=true;}else{state.yarn=form.querySelector('input[name=yarn]:checked').value;}})();   /* the page and the swatches must never disagree */

  input.addEventListener('input',function(){
    var raw=input.value,c=K.clean(raw);
    $('nameErr').textContent=/[^A-Za-z '\-‘’]/.test(raw)?'Letters, spaces, hyphens and apostrophes only. Numbers and symbols cannot be knitted.':'';
    if(c!==state.name){state.name=c;$('spellOk').checked=false;clearMissed();}
    changed();
  });
  function clearMissed(){$('spellWrap').classList.remove('is-missed');$('spellErr').textContent='';}
  $('spellOk').addEventListener('change',clearMissed);
  $('nameLater').addEventListener('click',function(){
    state.later=!state.later;this.setAttribute('aria-pressed',state.later?'true':'false');
    input.disabled=state.later;$('spellWrap').hidden=state.later;$('nameErr').textContent='';clearMissed();
    $('laterText').textContent=state.later?'We’ll knit it once we have the name.':'Name not decided yet?';this.textContent=state.later?'Add the name now':'Send it later';
    $('eta').classList.toggle('is-later',state.later);shKey='';labels();drawStage();queue();
    clearTimeout(heroT);heroT=setTimeout(function(){drawHero(false);},180);
  });
  form.addEventListener('change',function(e){if(e.target.name==='yarn'){state.yarn=e.target.value;changed();}});
  Array.prototype.forEach.call(document.querySelectorAll('.stage__tabs button'),function(b){
    b.addEventListener('click',function(){
      view=b.dataset.view;
      Array.prototype.forEach.call(document.querySelectorAll('.stage__tabs button'),function(o){o.setAttribute('aria-pressed',o===b?'true':'false');});
      knit.hidden=view!=='whole';close.hidden=view!=='close';knit.style.transform=close.style.transform='';drawStage();
    });
  });

  /* Turn the blanket over. The image swings away, the side changes, and it swings back. */
  $('flipBtn').addEventListener('click',function(){
    var cv=view==='whole'?knit:close,next=side==='front'?'back':'front';
    if(still){side=next;labels();drawStage();return;}
    cv.style.transition='transform .24s cubic-bezier(.55,0,.9,.45)';cv.style.transform='rotateY(90deg)';
    setTimeout(function(){
      side=next;labels();drawStage();
      cv.style.transition='none';cv.style.transform='rotateY(-90deg)';void cv.offsetWidth;
      cv.style.transition='transform .42s cubic-bezier(.16,.84,.24,1)';cv.style.transform='rotateY(0deg)';
    },240);
  });

  /* Hero: names type themselves out, one after another. Unhurried: type, hold, clear, next.
     If the visitor has already typed a name further down, theirs leads the list. */
  (function(){
    var el=$('typedName'),names=['Isla','Arthur','Florence','Theo','Willow','Margot','Rafferty','Ottilie'];
    function nice(n){return n.toLowerCase().replace(/(^|[ '\-])([a-z])/g,function(m,a,b){return a+b.toUpperCase();});}
    function list(){var mine=state.name&&state.name!==K.clean(input.defaultValue)&&nice(state.name);return mine&&names.indexOf(mine)<0?[mine].concat(names):names;}  /* only a name the visitor typed leads; the box's default does not */
    /* Frozen only for screenshots (#static). With Reduce Motion on, the names still change, but as a
       plain swap every few seconds: no typing, no blinking cursor. */
    if(/^#static/.test(location.hash)){el.textContent=list()[0];return;}
    if(still){
      var k=0;el.textContent=list()[0];
      setInterval(function(){if(document.hidden)return;var all=list();k=(k+1)%all.length;el.textContent=all[k];},3200);
      return;
    }
    var i=0,pos=list()[0].length,dir=-1,visible=true,t=0;
    if('IntersectionObserver' in window)new IntersectionObserver(function(en){visible=en[0].isIntersecting;if(visible){clearTimeout(t);t=setTimeout(step,400);}},{threshold:0}).observe(el);
    function step(){
      if(!visible||document.hidden){t=setTimeout(step,600);return;}
      var all=list(),word=all[i%all.length],wait;
      if(dir>0){pos++;wait=pos>=word.length?1900:95+Math.random()*60;if(pos>=word.length)dir=-1;}
      else{pos--;wait=45;if(pos<=0){pos=0;dir=1;i++;wait=200;}}
      el.textContent=(dir>0||pos>0?all[i%all.length]:word).slice(0,pos);
      el.parentNode.classList.toggle('is-empty',pos===0);
      t=setTimeout(step,wait);
    }
    t=setTimeout(step,2200);
  })();

  /* making queue and delivery date. Sample numbers: in the live theme these come from shop
     metafields kept current by a tool that counts open orders, so the date is always true. */
  /* Sample numbers. In the live theme these come from shop metafields kept current by a tool that
     counts open orders. showFrom: below this many open orders the queue line is hidden, because a
     near-empty queue is not persuasive and must never be padded. */
  var QUEUE={count:14,perWeek:12,leadDays:21,weeksCovered:3,cutoffHour:14,knitDaysBefore:6,wrapDaysBefore:3,showFrom:5};
  if(window.HEIR_SHOP)QUEUE.count=parseInt(window.HEIR_SHOP.queue,10)||0;  /* real open orders, from a shop metafield; 0 hides the line */
  var LOC=(window.HEIR_SHOP&&window.HEIR_SHOP.locale)||'en-US';  /* date words follow the market: en-US everywhere but the UK */
  function weekdayBack(d){while(d.getDay()===0||d.getDay()===6)d.setDate(d.getDate()-1);return d;}
  function queue(){
    var now=new Date(),closed=now.getHours()>=QUEUE.cutoffHour,pad=function(n){return(n<10?'0':'')+n;};
    var over=Math.max(0,QUEUE.count+1-QUEUE.perWeek*QUEUE.weeksCovered),extra=Math.ceil(over/QUEUE.perWeek)*7;
    /* The date shown is the one the NEXT cut off guarantees: today's list if still open, else tomorrow's. */
    var eta=new Date(now);eta.setDate(eta.getDate()+QUEUE.leadDays+extra+(closed?1:0));
    if(eta.getDay()===6)eta.setDate(eta.getDate()+2);if(eta.getDay()===0)eta.setDate(eta.getDate()+1);
    var text=eta.toLocaleDateString(LOC,{weekday:'long',day:'numeric',month:'long'});
    ['etaDate','deliveryEta','bagEta'].forEach(function(id){if($(id))$(id).textContent=(state.later&&id!=='deliveryEta')?'Three weeks after we have the name':text;});
    Array.prototype.forEach.call(document.querySelectorAll('.js-eta'),function(el){el.textContent=text;});
    var short=function(d){return d.toLocaleDateString(LOC,{day:'numeric',month:'short'});};
    var knit=weekdayBack(new Date(eta.getFullYear(),eta.getMonth(),eta.getDate()-QUEUE.knitDaysBefore)),wrap=weekdayBack(new Date(eta.getFullYear(),eta.getMonth(),eta.getDate()-QUEUE.wrapDaysBefore));
    $('stopOrdered').textContent=closed?'Tomorrow':'Today';$('stopKnit').textContent=short(knit);$('stopWrap').textContent=short(wrap);$('stopEta').textContent=short(eta);
    var end=new Date(now);end.setHours(QUEUE.cutoffHour,0,0,0);if(closed)end.setDate(end.getDate()+1);
    var sec=Math.max(0,Math.round((end-now)/1000));
    $('cutoff').textContent=pad(Math.floor(sec/3600))+':'+pad(Math.floor(sec/60)%60)+':'+pad(sec%60);
  }
  (function(){
    var panel=$('eta'),num=$('queueNum');
    $('etaProof').hidden=QUEUE.count<QUEUE.showFrom;
    function enter(){
      panel.classList.add('is-in');
      if(still){num.textContent=QUEUE.count;return;}
      var t0=null,dur=1400;
      (function tick(t){if(t0===null)t0=t;var p=Math.min(1,(t-t0)/dur);num.textContent=Math.round(QUEUE.count*(1-Math.pow(1-p,2)));if(p<1)requestAnimationFrame(tick);})(performance.now());
    }
    if(still||!('IntersectionObserver' in window)){enter();return;}
    var io=new IntersectionObserver(function(en){if(en[0].isIntersecting){io.disconnect();enter();}},{threshold:.35});io.observe(panel);
  })();
  queue();setInterval(queue,1000);

  /* The bag. Opened as a file it is a demo. On the store (window.HEIR_SHOP set by the theme) it is
     the real Shopify cart: add, remove, gift note, checkout. The name travels as a line item property. */
  var SHOP=window.HEIR_SHOP||null,bag=null,bagExtra=0,lastFocus=null,toastT=0,busy=false;
  /* Every cart route hangs off the market's root (/ or /en-gb/): a subfolder visitor who posted to /cart/add.js would land in the other market's cart and currency. */
  var ROOT=((SHOP&&SHOP.root)||'/').replace(/\/?$/,'/');
  function flash(msg){var t=$('toast');t.textContent=msg;t.classList.add('is-on');clearTimeout(toastT);toastT=setTimeout(function(){t.classList.remove('is-on');},3200);}
  function post(url,body){return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||j.message||'Something went wrong.');return j;});});}
  function yarnFromTitle(title){title=String(title||'').toLowerCase();for(var k in K.YARNS)if(K.YARNS[k].label.toLowerCase()===title)return k;return'chocolate';}
  function variantFor(label){label=label.toLowerCase();for(var t in SHOP.variants)if(t.toLowerCase()===label)return SHOP.variants[t];return null;}
  function bagDraw(){
    var has=!!bag;$('bagEmpty').hidden=has;$('bagItem').hidden=!has;$('drawerFoot').hidden=!has;$('bagCount').textContent=has?String(1+bagExtra):'0';
    var more=$('bagMore');more.hidden=!(has&&bagExtra);
    if(has&&bagExtra){more.textContent='Plus '+bagExtra+' more already in your bag, which may be a different '+(SHOP&&SHOP.gb?'colour':'color')+'. ';var a=document.createElement('a');a.className='link';a.href=ROOT+'cart';a.textContent='See everything';more.appendChild(a);}
    if(!has)return;
    $('bagName').textContent=bag.later?LATER:bag.name;$('bagYarn').textContent=yname(K.YARNS[bag.yarn]);
    var m=$('bagKnit');m.width=m.height=640;K.studio(m,K.sheets(bag.later?'HEIR':bag.name,bag.yarn,2));
  }
  function bagOpen(){lastFocus=document.activeElement;document.body.classList.add('is-bag');$('bagClose').focus();}
  function bagClose(){document.body.classList.remove('is-bag');if(lastFocus)lastFocus.focus();}
  var lastAddedKey=null;
  function fromCart(cart){
    var mine=cart.items.filter(function(i){return i.properties&&i.properties.Name;});
    if(!mine.length){bag=null;bagExtra=0;}
    else{var it=mine.filter(function(i){return i.key===lastAddedKey;})[0]||mine[0];bag={name:K.clean(it.properties.Name),later:it.properties['Name to follow']==='Yes',yarn:yarnFromTitle(it.variant_title||''),key:it.key};bagExtra=Math.max(0,cart.item_count-1);}
    if(cart.note&&!$('giftMsg').value)$('giftMsg').value=cart.note;
    bagDraw();
  }
  function add(){
    var err=$('nameErr');
    if(!state.later&&!state.name.replace(/[^A-Z]/g,'')){err.textContent='Type the name you would like knitted, or choose to send it later.';input.focus();input.scrollIntoView({block:'center'});return;}
    err.textContent='';
    if(!state.later&&!$('spellOk').checked){var w=$('spellWrap');$('spellErr').textContent='Please tick to confirm the spelling of '+state.name+'.';w.classList.remove('is-missed');void w.offsetWidth;w.classList.add('is-missed');$('spellOk').focus({preventScroll:true});w.scrollIntoView({block:'center'});return;}
    if(!SHOP){bag={name:state.name,later:!!state.later,yarn:state.yarn};bagDraw();bagOpen();return;}
    var tickedSwatch=form.querySelector('input[name=yarn]:checked');if(tickedSwatch&&tickedSwatch.value!==state.yarn){state.yarn=tickedSwatch.value;changed();}
    var y=K.YARNS[state.yarn],v=variantFor(y.label);
    if(!v){flash(yname(y)+' is not on sale yet.');return;}
    if(!v.available){flash(yname(y)+' is not available at the moment.');return;}
    if(busy)return;busy=true;
    lastAddedKey=null;
    post(ROOT+'cart/add.js',{items:[{id:v.id,quantity:1,properties:state.later?{'Name':LATER,'Name to follow':'Yes','Colours':y.label}:{'Name':state.name,'Colours':y.label,'Spelling confirmed':'Yes'}}]})
      .then(function(added){if(added&&added.items&&added.items[0])lastAddedKey=added.items[0].key;return fetch(ROOT+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();});})
      .then(function(cart){busy=false;fromCart(cart);bagOpen();document.dispatchEvent(new CustomEvent('heir:add_to_cart',{detail:{variantId:v.id,name:state.name,colours:y.label,price:v.price/100,currency:SHOP.currency}}));})
      .catch(function(e){busy=false;flash(e.message||'Could not add to your bag. Please try again.');});
  }
  form.addEventListener('submit',function(e){e.preventDefault();add();});
  $('barBtn').addEventListener('click',add);
  $('bagOpen').addEventListener('click',bagOpen);$('bagClose').addEventListener('click',bagClose);$('scrim').addEventListener('click',bagClose);
  $('bagEmptyLink').addEventListener('click',bagClose);
  $('bagRemove').addEventListener('click',function(){
    if(!SHOP||!bag||!bag.key){bag=null;bagDraw();return;}
    post(ROOT+'cart/change.js',{id:bag.key,quantity:0}).then(fromCart).catch(function(e){flash(e.message);});
  });
  $('checkoutBtn').addEventListener('click',function(){
    if(!SHOP){flash('Checkout opens here on the live shop.');return;}
    var go=function(){window.location.href=ROOT+'checkout';};
    post(ROOT+'cart/update.js',{note:$('giftMsg').value.trim()}).then(go,go);
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&document.body.classList.contains('is-bag'))bagClose();});
  // /cart redirects here as #bag (the checkout's bag icon links to /cart): open the drawer once the real cart is in, then drop the hash.
  function openIfAsked(){if(/^#bag\b/.test(location.hash)){bagOpen();history.replaceState(null,'',location.pathname+location.search);}}
  if(!SHOP)openIfAsked();
  if(SHOP){
    fetch(ROOT+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(fromCart).catch(function(){}).then(openIfAsked);
    Array.prototype.forEach.call(document.querySelectorAll('[data-shop-href]'),function(a){a.href=a.getAttribute('data-shop-href');});
  }

  /* gallery */
  var lb=$('lightbox');
  Array.prototype.forEach.call(document.querySelectorAll('.tile'),function(t){t.addEventListener('click',function(){var img=t.querySelector('img'),big=new Image();big.src=img.src;big.alt=img.alt;var fig=$('lightboxFig');fig.textContent='';fig.appendChild(big);if(lb.showModal)lb.showModal();});});
  $('lightboxClose').addEventListener('click',function(){lb.close();});
  lb.addEventListener('click',function(e){if(e.target===lb)lb.close();});

  if('IntersectionObserver' in window){new IntersectionObserver(function(en){$('bar').classList.toggle('is-on',!en[0].isIntersecting&&en[0].boundingClientRect.top<0);},{threshold:0}).observe(form);}

  if('IntersectionObserver' in window){
    var tileSeen=true,formSeen=false,miniBtn=$('mini');
    var miniSync=function(){var on=!tileSeen&&formSeen;miniBtn.classList.toggle('is-on',on);miniBtn.tabIndex=on?0:-1;if(on)drawMini();};
    new IntersectionObserver(function(en){tileSeen=en[0].isIntersecting;miniSync();},{threshold:.15}).observe(document.querySelector('.stage__tile'));
    new IntersectionObserver(function(en){formSeen=en[0].isIntersecting;miniSync();},{threshold:0}).observe(form);
    miniBtn.addEventListener('click',function(){document.querySelector('.stage__tile').scrollIntoView({block:'center',behavior:still?'auto':'smooth'});});
  }

  var rt=0,lastW=0;
  window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){if(window.innerWidth!==lastW){lastW=window.innerWidth;drawStage();drawHero(false);}},160);});
  lastW=window.innerWidth;labels();drawStage();drawHero(false);bagDraw();
  if('IntersectionObserver' in window&&!still){var seen=new IntersectionObserver(function(en){if(en[0].isIntersecting){seen.disconnect();drawHero(true);}},{threshold:.35});seen.observe(hero);}
})();
